<template>
  <div class="footer">
    <div class="help">
      <a href="/" class="logo"
        ><img
          src="../../assets/images/global/logo.png"
          alt="杭州泛钛科技有限公司"
      /></a>
      <div class="cont">
        <div class="item" v-for="(item, index) in footList" :key="index">
          <div class="item-box">
            <span class="item_title">{{ item.name }}</span>
            <div
              class="item_child af"
              v-for="(jtem, jndex) in item.children"
              :key="jndex"
              @click="go(jtem)"
              style="cursor: pointer"
            >
              {{ jtem.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">
      <span class="name">Copyright @2017杭州泛钛科技有限公司</span
      ><a
        href="https://beian.miit.gov.cn/"
        class="bah af"
        style="cursor: pointer"
        >浙ICP备17045287号-1</a
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      footList: [
        {
          name: "产品与服务",
          children: [
            { name: "客户案例", href: "/product" },
            { name: "解决方案", href: "/solve" },
          ],
        },
        {
          name: "关于",
          children: [
            // { name: '关于我们', href: "/about" },
            { name: "联系我们", href: "/contact" },
            // { name: '人才招聘', href: "/job" }
          ],
        },
        {
          name: "合作",
          children: [
            { name: "Biz@fintechgp.com", href: "mailto://Biz@fintechgp.com" },
          ],
        },
      ],
    };
  },
  methods: {
    go(item) {
      if (item.href == "mailto://Biz@fintechgp.com") {
        window.open("mailto://Biz@fintechgp.com");
      } else {
        this.$router.push({
          path: item.href,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  color: #999999;
  // text-decoration: underline !important;
}

a:hover {
  color: #0c0fda;
}

.af:hover {
  color: #1926db;
}

.footer {
  width: 100%;
  height: 486px;
  // color: #000000;
  color: #999999;
  background: #ffffff;
  background-image: url(../../assets/images/footer/foot\ 38.png);
  background-size: 1920px 486px;
}

.help {
  width: 1600px;
  height: 201px;
  border-bottom: 1px solid #9ba7c1;
  margin: 0 auto;
  padding-top: 96px;
  max-width: 1600px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

.logo {
  margin-bottom: 140px;
  line-height: 0;
  display: block;
  flex: 0;
}

.logo img {
  width: 338px; /* 宽度为338px */
  height: 60px; /* 高度为60px */
  background-size: 100% 100%;
}

.cont {
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: flex-start;
  margin-left: 531px;
  height: 200px;
  align-items: flex-start;
}

.item {
  // padding: 0.4rem 0 0.2rem;
  line-height: 30px;
  height: 30px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
  align-items: end;
  // text-align: end;
}

.item_title {
  line-height: 30px;
  color: #333333;
  margin-bottom: 20px;
  font-size: 18px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 550;
  color: #333333;
}
.item_child {
  line-height: 30px;
  margin-bottom: 0.2rem;
  color: #666666;
}

.copyright {
  width: 1600px;
  padding: 0.2rem 0;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 14px;
  text-align: center;
  margin: 0 auto;
  padding-top: 55px;
  max-width: 1196px;
}

.bah {
  margin-left: 0.1rem;
}

@media screen and (max-width: 768px) {
  .logo img {
    width: 4rem;
  }

  .item {
    // padding: 0.6rem 0 0.4rem;
    line-height: 0.3rem;
    font-size: 0.2rem;
  }

  .copyright {
    color: #999999;
    padding: 0.4rem 0;
    line-height: 0.4rem;
    font-size: 0.2rem;
    font-family: PingFang SC;
    font-weight: 500;
  }
}

@media screen and (max-width: 580px) {
  .cont {
    // padding: 0.2rem 0 0.4rem;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
  }

  .item {
    // padding: 0.4rem 0 0;
    line-height: 0.3rem;
    font-size: 0.2rem;
  }

  .copyright span,
  .copyright a {
    display: block;
  }
}
</style>